import { Box } from '@mui/material';
import { neutral } from '@ahora-patagonia/design-tokens';
import type { NotaPublicaCard } from '@ahora-patagonia/contracts';
import { FilaNotaMiniatura } from './FilaNotaMiniatura.js';

/**
 * Listado **uniforme** de categoría y búsqueda: todas las notas con el mismo tratamiento
 * (miniatura 4:3, titular, firma; sin bajada y sin nota destacada). La jerarquía es cosa de
 * la portada — un listado es un índice cronológico, y destacar la primera implicaría un
 * criterio editorial que nadie cargó.
 */
export function ListadoNotas({ notas }: { notas: NotaPublicaCard[] }) {
  return (
    <Box component="section">
      {notas.map((nota, i) => (
        <Box
          key={nota.id}
          sx={{ py: 1.5, ...(i > 0 ? { borderTop: `1px solid ${neutral[300]}` } : {}) }}
        >
          <FilaNotaMiniatura nota={nota} />
        </Box>
      ))}
    </Box>
  );
}
